export enum MenuType {
    title,
    link,
    sub,
    divider
}
export interface BadgeItem {
    type: string;
    value: string;
}
export interface MenuItem {
    pageId?: number;
    flag?: number;
    type: MenuType;
    url?: string;
    name?: string;
    icon?: string;
    badge?: BadgeItem[];
    children?: MenuItem[];
}
export interface Menu {
  type: MenuType;
  state?: string;
  name?: string;
  icon?: string;
  badge?: BadgeItem[];
  children?: Menu[];
}
